import { render, staticRenderFns } from "./FeaturePicker.vue?vue&type=template&id=8446eaa2&"
import script from "./FeaturePicker.vue?vue&type=script&lang=js&"
export * from "./FeaturePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports